<template>
    <a
        v-bind="$attrs"
        class="search-result-document"
        :data-bot="context ? `search-result__document--${context}` : 'search-result__document'"
        :class="classes"
        :href="link"
        @mouseenter="handleMouseEnter"
        @mouseleave="isHovered = false"
    >
        <CompassObject size="extra-small" type="object" object="document" />
        <div class="search-result-document__content">
            <div class="search-result-document__title">
                <h5
                    class="search-result-document__name typographies-paragraph-medium-bold"
                    v-html="number"
                />
                <div v-if="status" class="document-status">
                    <CompassTag
                        size="small"
                        :color="statusInformation.color"
                        :icon="statusInformation.icon"
                    >
                        {{ status.label }}
                    </CompassTag>
                </div>
            </div>
            <ul
                v-if="checkDocumentDetails"
                class="search-result-document__details typographies-paragraph-medium-regular"
            >
                <li
                    v-if="checkRelatedObject"
                    class="typographies-paragraph-medium-semibold search-result-document__company"
                >
                    <CompassLink
                        type="secondary"
                        :link="relatedObject.url"
                        v-html="relatedObject.name"
                    />
                </li>
                <li v-if="!amount.includes('undefined')" class="search-result-document__amount">
                    {{ amount }}
                </li>
                <li v-if="name" class="search-result-document__subject">
                    <span v-html="name" />
                </li>
            </ul>
            <div
                v-for="(extraField, index) in getHighlightedExtraFields"
                :key="index"
                class="typographies-paragraph-medium-regular search-result-document__extra-field"
            >
                <span> {{ extraField.label }}</span>
                <span v-html="extraField.value" />
            </div>
        </div>
    </a>
</template>
<script>
import { allStatus } from 'Dictionaries/statusColors';
import SearchResultsGeneric from './SearchResultsGeneric.vue';

export default {
    extends: SearchResultsGeneric,
    props: {
        name: {
            type: String,
            default: '',
        },
        amount: {
            type: String,
            default: '',
        },
        related: {
            type: Object,
            required: true,
        },
        status: {
            type: Object,
            default: null,
        },
        number: {
            type: String,
            required: true,
        },
    },
    computed: {
        statusInformation() {
            return allStatus[this.status.id];
        },
        relatedObject() {
            return {
                name:
                    this.related.type === 'individual'
                        ? `${this.related.first_name} ${this.related.last_name}`
                        : this.related.name,
                url: this.related.link,
            };
        },
        checkRelatedObject() {
            return this.relatedObject.name && this.relatedObject.url;
        },
        checkDocumentDetails() {
            return this.checkRelatedObject || !this.amount.includes('undefined') || this.name;
        },
        classes() {
            return {
                'search-result-document--is-hovered': this.isHovered,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.search-result-document {
    align-items: flex-start;
    cursor: pointer;
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-3);

    :deep(.highlight) {
        background: var(--colors-common-background-highlight-search);
    }

    &--is-hovered {
        background: var(--colors-common-background-hover, #f6f6f9);
    }

    &__title {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
    }

    &__content {
        min-width: 0;
    }

    .document-status {
        color: var(--colors-common-text-standard-default, #111);
    }

    :deep(.compass-link) {
        display: inline;
    }

    :deep(.compass-object) {
        flex-shrink: 0;
    }

    &__name {
        color: var(--colors-common-text-standard-default, #111);
        margin: 0;
    }

    &__details {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-2);
        margin: var(--spacing-0) 0 0;
    }

    &__extra-field {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-0);
        padding: var(--spacing-0) 0 0;
    }

    &__amount {
        flex-shrink: 0;
    }

    &__company {
        flex-shrink: 0;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__subject {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        line-clamp: 1;
    }
}
</style>
